import renderDom from "./render.js"
import jsonp from '../../../common/jsonp'
const init = () => {
    console.log('---commercial-tz-banner start---')
    jsonp({
        url: 'https://legohyapi.58.com/infoTop/state/get',
        params:{
            infoId: window.commercial.entityidlist
        },
        success(res){
            const { code, data } = res
            if (code === 200 && data.isAvailable && !data.isExist) renderDom()
        }
    })
}

export default init